import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
import { ProductCell, ProductColorLabel } from "modules/products";
import moment from "moment";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable } from "ui";

import { NeverSoldProductsListItem } from "../../insights.types";
import { NeverSoldProductsTableProps } from "./NeverSoldProductsTable.types";

import styles from "./NeverSoldProductsTable.module.scss";

const NeverSoldProductsTable = ({
  products,
  sorting,
  setSorting,
  isLoading
}: NeverSoldProductsTableProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const columns: Array<
    ColumnDef<NeverSoldProductsListItem, NeverSoldProductsListItem[]>
  > = useMemo(
    () => [
      {
        header: t("Product"),
        size: 48,
        minSize: 48,
        cell: ({ row }) => (
          <ProductCell
            image={products[row.index].image}
            name={products[row.index].name}
            imageClassName={styles.table_productImage}
            subtitle={
              <>
                <span>{products[row.index].sku}</span>
                <span>·</span>
                <ProductColorLabel
                  colorValue={products[row.index].colorAttributeValue.value}
                />
              </>
            }
          />
        )
      },
      {
        id: "quantity",
        accessorKey: "quantity",
        header: t("Qty"),
        size: 10,
        minSize: 10,
        cell: ({ row }) => products[row.index].availableItemsCount
      },
      {
        id: "buyingPrice",
        accessorKey: "buyingPrice",
        header: t("Buying Price"),
        size: 15,
        minSize: 15,
        cell: ({ row }) =>
          products[row.index].buyingPrice.toLocaleString("en-US")
      },
      {
        id: "StandardPrice",
        accessorKey: "StandardPrice",
        header: t("Standard Price"),
        size: 15,
        minSize: 15,
        cell: ({ row }) =>
          products[row.index].standardPrice.toLocaleString("en-US")
      },
      {
        id: "createdAt",
        accessorKey: "createdAt",
        header: t("Item Created"),
        size: 15,
        minSize: 15,
        cell: ({ row }) => (
          <pre>
            {`${moment(products[row.index].createdAt).format("DD/MM/YYYY")}`}
            {"\n"}
            {`${moment(products[row.index].createdAt).format("HH:mm")}`}
          </pre>
        )
      }
    ],
    [products, currentLanguage]
  );

  return (
    <ItemsTable
      className={styles.table}
      columns={columns}
      data={products}
      sorting={sorting}
      skeletonHeight={60}
      setSorting={setSorting}
      isLoading={isLoading}
      getLinkUrl={({ subSubCategoryId, productId, id }) => {
        return `/products/details/${subSubCategoryId}/${productId}/${id}/boxes`;
      }}
      linkTarget="_blank"
    />
  );
};

export default NeverSoldProductsTable;
